import CrmPage from "../features/crm/CrmPage";

export default function CrmRoute() {
  return <CrmPage />;
}
